module.exports = ".input-group .form-control {\r\n    width: 103%;\r\n}\r\n.table th, .table td {\r\n    border-top: 0px solid white;\r\n}\r\n.align-right{\r\n    text-align: right\r\n}\r\n.form-control[readonly] {\r\n    pointer-events: none;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/validate-loss-data-submission/shared/total-claim-calculator/total-claim-calculator.component.css
// module id = ./src/app/modules/validate-loss-data-submission/shared/total-claim-calculator/total-claim-calculator.component.css
// module chunks = main